import React from 'react';
import useStyle from './tableDivider.style';

interface TableDividerProps {
  isVisible: boolean;
}

export const TableDivider = ({ isVisible }: TableDividerProps) => {
  const classes = useStyle();
  return <>{isVisible && <tr className={classes.root}></tr>}</>;
};
